import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="w-full bg-cream-100" aria-labelledby="garantia-titulo" data-id="element-38" data-mp="4vryttha25or">
      <div className="mx-auto max-w-4xl px-5 py-16 lg:py-24" data-id="element-39" data-mp="9tbhd5l0d4mi">
        <div className="rounded-3xl border-2 border-dashed border-clay-400 bg-cream-50 p-8 text-center sm:p-12" data-id="element-40" data-mp="et65x2hb9i4e">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-forest-900" data-id="element-41" data-mp="jt2b351qvflj">
            <ShieldCheckIcon className="h-8 w-8 text-clay-400" aria-hidden="true" data-id="element-42" data-mp="ntcdy8u8ppw6" />
          </span>
          <h2 id="garantia-titulo" className="mt-6 font-display text-3xl font-bold text-forest-900 sm:text-4xl" data-id="element-43" data-mp="skkox9b7xjbg">
            Garantía de Satisfacción Total
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-forest-800/80" data-id="element-44" data-mp="12k34zeo0cky8">
            Si en 7 días no ves una mejora en el brillo del pelaje o la energía de tu perro, te
            devuelvo el 100% de tu dinero. Sin preguntas.{' '}
            <strong className="font-semibold text-forest-900" data-id="element-45" data-mp="25pkkhr9gjlcy">El riesgo es todo mío.</strong>
          </p>
          <div className="mt-8 flex justify-center" data-id="element-46" data-mp="1vtr9icbdzzxa">
            <CtaButton data-id="element-47" data-mp="1vuiwiyqx4pby" />
          </div>
        </div>
      </div>
    </section>;
}